<template>
    <section class="content">
        <div class="container-fluid">
            <div class="row">
                <div class="col-12" v-if="select_region">
                    <div class="card">
                        <div class="card-header">
                            <h3 class="card-title">Seleccionar la región:</h3>
                            <div class="card-tools">
                                <router-link :to="{ name: 'back.abonos.listado-bloqueos'}" class="btn btn-primary mr-lg-3">
                                    Listado de bloqueos
                                </router-link>
                            </div>
                        </div>
                            
                        <div class="card-body">
                            <div class="row">
                                <div class="col-12 text-center" v-if="!loading">                                        
                                    <CleSvgComponent 
                                        v-if="zonas.length > 0"
                                        :zonas="zonas" 
                                        :place="place"
                                        @clickZona="irAZona"
                                    />
                                </div>
                                <div class="col-12 text-center" style="height: 150px" v-if="loading">
                                    <LoaderComponent/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12" v-if="select_butacas">
                    <div class="card">
                        <div class="card-header">
                            <h2 class="card-title">Region: {{ zona.name }}</h2>
                            <div style="margin-top: 45px;"></div>
                            <h3 class="card-title">Seleccionar butacas:</h3>
                            <div class="card-tools">
                                <Button type="button" name="button" @click="volver">Cambiar región</Button>
                            </div>
                        </div>
                            
                        <div class="card-body">
                            <BloquearAsientosNormales
                                v-if="zona && ! zona.tiene_plazas"
                                :zona_seleccionada="zona"
                            />
                            <BloquearPlazasRegionAnexa
                                v-if="zona && zona.tiene_plazas"
                                :zona="zona"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import LoaderComponent from '@/components/preloader/LoaderComponent';
    import CleSvgComponent from '@/components/backend/stepper/components/CleSvgComponent';

    import BloquearAsientosNormales from '../../../../../components/backend/abonos/bloquear-asientos/BloquearAsientosNormales.vue';
    import BloquearPlazasRegionAnexa from '../../../../../components/backend/abonos/bloquear-asientos/BloquearPlazasRegionAnexa.vue';

    export default {
        data() {
            return {
                loading: true,
                zonas: [],
                zona: null,
                select_region: true,
                select_butacas: false,
            }
        },
        created() {
            this.getZonas(this.place.id);
        },
        computed: {
            place() {
                return this.$store.getters.getRecinto;
            },
            configuracion() {
                return this.$store.getters.getConfig;
            },
            manager() {
                return this.$store.getters.getFooter;
            },
        },
        methods: {
            getZona(id) {
                this.loading = true;
                const params = {
                    filters: {
                        zona_id: id,
                        conf: true
                    },
                };

                this.$store.dispatch(this.config.getVuexAlias('zonas.index'), params).then(res => {
                    this.select_region = false;
                    this.select_butacas = true;
                    this.filas = res.data.configuracion_asientos;
                    this.loading = false;
                    this.zona.total_asientos = res.data.total_asientos;
                    this.zona.bloqueados = res.data.bloqueados;
                    this.zona.ocupados = res.data.ocupados;
                });
            },
            getZonas(place_id) {
                this.loading = true;
                const params = {
                    filters: {
                        place_id: place_id
                    }
                };
                this.$store.dispatch(this.config.getVuexAlias('zonas.index'), params).then(res => {
                    this.zonas = res.data;
                    if (place_id) {
                        this.getZonasAnexas(place_id);
                    } else {
                        this.loading = false;
                    }
                });
            },
            volver() {
                this.asientos = [];
                this.zona = null;
                this.select_region = true;
                this.select_butacas = false;
            },
            irAZona(paso, zona) {
                this.getZona(zona.id);
                this.zona = zona;
            },
            getZonasAnexas(place_id) {
                const params = {
                    filters: {},
                    lista_id: this.$store.getters.getListaId,
                    recinto_id: place_id
                }

                this.$store.dispatch(this.config.getVuexAlias('back.abonos.taquilla.regiones-anexas'), params).then(res => {
                    this.zonas = this.zonas.concat(res.data.data);
                    this.loading = false;
                })
            }
        },
        components: {
            LoaderComponent, CleSvgComponent, BloquearAsientosNormales, BloquearPlazasRegionAnexa
        }
    }

</script>